module.exports = __webpack_public_path__ + "img/grey_arrow.58bb0ca7.svg";